import styled from "styled-components";

export const NotificationMainContainer = styled.main`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  color: #101e8e;
`;

export const NotificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;
  align-items: center;
`;

export const Notification = styled.div`
  width: 90%;
  background: #fff;
  border-left:6px solid #62AA51;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #101e8e;
  padding: 0.2rem 2rem;
  font-weight: bold;
  p{
    font-weight: 500;
  }
  a{
    color: #101e8e;
    text-decoration: underline;
  }
`;

export const NotificationRead = styled.div`
  width: 90%;
  background: #fff;
  height:4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #101e8e;
  padding: 0.2rem 2rem;
  font-weight: bold;
  p{
    font-weight: 500;
  }
`;

